import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SLICE_BASE_NAME } from './constants'

export type CommonState = {
    currentRouteKey: string
    navigationBadges?: any
}

export const initialState: CommonState = {
    currentRouteKey: '',
    navgationBadges: {},
}

export const commonSlice = createSlice({
    name: `${SLICE_BASE_NAME}/common`,
    initialState,
    reducers: {
        setCurrentRouteKey: (state, action: PayloadAction<string>) => {
            state.currentRouteKey = action.payload
        },
        setNavigationBadges: (state, action: PayloadAction<any>) => {
            state.navigationBadges = action.payload || {}
        }
    },
})

export const { setCurrentRouteKey, setNavigationBadges } = commonSlice.actions

export default commonSlice.reducer
